import { Action } from 'redux';

import { SetCustomDomainEnabled } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';


export interface SetCustomDomainEnabledAction extends Action {
  customDomainEnabled: boolean;
}

export function setCustomDomainEnabled(customDomainEnabled: boolean): SetCustomDomainEnabledAction {
  return {
    type: SetCustomDomainEnabled,
    customDomainEnabled
  };
}
export const isSetCustomDomainEnabledAction = isActionFactory<SetCustomDomainEnabledAction>(SetCustomDomainEnabled);
